'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useTransition } from 'react';

const CATEGORY_QUERY_PARAM = 'category';

export const useAchievementCategoryFilters = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();

  const selectedIds = searchParams?.getAll(CATEGORY_QUERY_PARAM) ?? [];

  const setSelectedCategories = (categoryIds: string[]) => {
    const params = new URLSearchParams();
    categoryIds.forEach((id) => params.append(CATEGORY_QUERY_PARAM, id));
    const qs = params.toString();
    startTransition(() => {
      router.replace(qs ? `${pathname}?${qs}` : pathname);
    });
  };

  return { selectedIds, isPending, setSelectedCategories };
};
